<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modal-editmod">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>Editar Modulo</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
              <div class="form-group" :class="{'has-error': validation.hasError('mod.nombre')}">
                <div class="input-group input-group-sm">
                  <div class="input-group-addon"> <span class="text-danger">*</span> Nombre</div>
                  <input type="text" v-model.trim="mod.nombre" class="form-control" placeholder="Solo letras">
                </div>
                <div class="error" v-if="validation.hasError('mod.nombre')"> {{validation.firstError('mod.nombre')}} </div>
              </div>
            </div>
            
            <Alertas 
                ref="alertar" 
                v-bind:msgSuccess="'Creado con exito.'"
                v-bind:msgLoading="'Aplicando...'"
                />
            <div class="modal-footer">
                <button @click="validarCampos" v-if="activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
import gql from 'graphql-tag'
import { Validator } from 'simple-vue-validator'
    export default {
      props:{ mod:Object },
        data(){
            return{
              activo: true,
            }
        },
        watch:{},
        components:{Alertas},
        validators: {
          'mod.nombre'(value){
            return Validator.value(value).required();
          },
        },
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            },
             validarCampos(){
              this.$validate().then((success) => {
                var obj = window.Object.assign( {},this.mod );
                  if (success) {
                    this.submit();
                  }else{
                    window.console.log( "HHHHH",window.stringifyObject(obj) );
                    this.$refs.alertar.invalido();
                  }
              });
            },
            submit(){
                var vue = this;
                vue.$refs.alertar.cargando();
                vue.activo = false;
                var sql = gql`mutation{ updateModulo(input:${window.stringifyObject(this.mod)}){ok,errors{message}}}`;
                window.console.log( sql );

                this.$apollo.mutate({
                    mutation: sql,
                }).then((data) => {
                    window.console.log(data);
                    if( data.data.updateModulo.ok ){
                      vue.$refs.alertar.success();
                      vue.$emit('exito');

                    }else{
                      var errores = JSON.stringify(data.data.registrarCargoUsuarioSede.errors);
                      var obj = JSON.parse( errores );
                      var vals = '';
                      obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                      vue.$refs.alertar.invalido( vue.$refs.alertar.invalido( vals ) );
                    }
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            }
        },
        mounted(){
          var vue = this;
          window.$('#modal-narea').on('hide',function(){ vue.mod.nombre=null;vue.estado=true; });
        }
    
    }
</script>